(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5568],{

/***/ 52004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MultiDropdown_MultiDropdown; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/router.js
var next_router = __webpack_require__(86317);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-accessible-dropdown-menu-hook@3.2.0/node_modules/react-accessible-dropdown-menu-hook/dist/use-dropdown-menu.js
var use_dropdown_menu = __webpack_require__(32821);
// EXTERNAL MODULE: ./components/global/Icon/index.tsx + 1 modules
var Icon = __webpack_require__(55689);
// EXTERNAL MODULE: ./components/global/Icon/defaultIconSizes.tsx
var defaultIconSizes = __webpack_require__(57556);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-accessible-accordion@5.0.0_zpnidt7m3osuk7shl3s4oenomq/node_modules/react-accessible-accordion/dist/es/index.js
var es = __webpack_require__(75101);
// EXTERNAL MODULE: ./lib/util.tsx + 1 modules
var util = __webpack_require__(70108);
// EXTERNAL MODULE: ./components/global/MultiDropdownItem/MultiDropdownItem.module.scss
var MultiDropdownItem_module = __webpack_require__(75288);
var MultiDropdownItem_module_default = /*#__PURE__*/__webpack_require__.n(MultiDropdownItem_module);
;// CONCATENATED MODULE: ./components/global/MultiDropdownItem/Item.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




var Item = function(param) {
    var item = param.item, onSelect = param.onSelect, active = param.active;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: (0,clsx_m/* default */.Z)(_defineProperty({}, (MultiDropdownItem_module_default())["DropdownItem--active"], active)),
        type: "button",
        onClick: function() {
            return onSelect(item);
        },
        children: item.label ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: item.label
        }) : item.name
    });
};
/* harmony default export */ var MultiDropdownItem_Item = (Item);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-range@1.8.14_zpnidt7m3osuk7shl3s4oenomq/node_modules/react-range/lib/index.js
var lib = __webpack_require__(87715);
// EXTERNAL MODULE: ./components/global/MultiDropdownItem/YearsSelector.module.scss
var YearsSelector_module = __webpack_require__(71069);
var YearsSelector_module_default = /*#__PURE__*/__webpack_require__.n(YearsSelector_module);
;// CONCATENATED MODULE: ./components/global/MultiDropdownItem/YearsSelector.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function YearsSelector_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            YearsSelector_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var YearsSelector = function(param1) {
    var years = param1.years, startYear = param1.startYear, endYear = param1.endYear, onSelect = param1.onSelect, mobile = param1.mobile;
    var MIN = parseInt(years[years.length - 1].id);
    var MAX = parseInt(years[0].id);
    var rtl = false;
    var ref = _slicedToArray(react.useState([
        startYear || MIN,
        endYear || MAX
    ]), 2), values1 = ref[0], setValues = ref[1];
    var handleValuesChange = function(values) {
        setValues(values);
        onSelect && onSelect([
            years.find(function(year) {
                return year.id === values[0].toString();
            }),
            years.find(function(year) {
                return year.id === values[1].toString();
            })
        ]);
    };
    // Set values if there's startYear & endYear props
    (0,react.useEffect)(function() {
        setValues([
            startYear,
            endYear
        ]);
    }, [
        startYear,
        endYear
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            mobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Range, {
                values: values1,
                step: 1,
                min: MIN,
                max: MAX,
                rtl: rtl,
                onChange: handleValuesChange,
                renderTrack: function(param) {
                    var props = param.props, children = param.children;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (YearsSelector_module_default()).YearsSelectorMobile__track,
                        onMouseDown: props.onMouseDown,
                        onTouchStart: props.onTouchStart,
                        style: _objectSpread({}, props.style),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            ref: props.ref,
                            className: (YearsSelector_module_default()).YearsSelectorMobile__trackInner,
                            style: {
                                background: (0,lib.getTrackBackground)({
                                    values: values1,
                                    colors: [
                                        "#f3f3f3",
                                        "#cbcbcb",
                                        "#f3f3f3"
                                    ],
                                    min: MIN,
                                    max: MAX,
                                    rtl: rtl
                                })
                            },
                            children: [
                                values1[1] !== MAX && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        position: "absolute",
                                        right: 0,
                                        transform: "translate(0, -4.5px)",
                                        height: "10px",
                                        width: "10px",
                                        borderRadius: "50%",
                                        backgroundColor: "var(--slider-grey)"
                                    }
                                }),
                                children,
                                values1[0] !== MIN && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        position: "absolute",
                                        left: 0,
                                        transform: "translate(0, -4.5px)",
                                        height: "10px",
                                        width: "10px",
                                        borderRadius: "50%",
                                        backgroundColor: "var(--slider-grey)"
                                    }
                                })
                            ]
                        })
                    });
                },
                renderThumb: function(param) {
                    var props = param.props, isDragged = param.isDragged, index = param.index;
                    var _obj;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", _objectSpread({}, props, {
                        style: _objectSpread({}, props.style),
                        className: (0,clsx_m/* default */.Z)((YearsSelector_module_default()).YearsSelectorMobile__thumb, (_obj = {}, YearsSelector_defineProperty(_obj, (YearsSelector_module_default())["YearsSelectorMobile__thumb--right"], index === 1), YearsSelector_defineProperty(_obj, (YearsSelector_module_default())["YearsSelectorMobile__thumb--equalValues"], index === 1 && values1[0] === values1[1]), _obj)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: props["aria-valuenow"]
                        })
                    }));
                }
            }),
            !mobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Range, {
                direction: lib.Direction.Up,
                values: values1,
                step: 1,
                min: MIN,
                max: MAX,
                rtl: rtl,
                onChange: handleValuesChange,
                renderTrack: function(param) {
                    var props = param.props, children = param.children;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (YearsSelector_module_default()).YearsSelector__track,
                        onMouseDown: props.onMouseDown,
                        onTouchStart: props.onTouchStart,
                        style: _objectSpread({}, props.style),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            ref: props.ref,
                            className: (YearsSelector_module_default()).YearsSelector__trackInner,
                            style: {
                                background: (0,lib.getTrackBackground)({
                                    values: values1,
                                    colors: [
                                        "#f3f3f3",
                                        "#cbcbcb",
                                        "#f3f3f3"
                                    ],
                                    min: MIN,
                                    max: MAX,
                                    direction: lib.Direction.Up,
                                    rtl: rtl
                                })
                            },
                            children: [
                                values1[1] !== MAX && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        position: "absolute",
                                        top: 0,
                                        transform: "translate(-4.5px, -4.5px)",
                                        height: "10px",
                                        width: "10px",
                                        borderRadius: "50%",
                                        backgroundColor: "var(--slider-grey)"
                                    }
                                }),
                                children,
                                values1[0] !== MIN && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        position: "absolute",
                                        bottom: 0,
                                        transform: "translate(-4.5px, 4.5px)",
                                        height: "10px",
                                        width: "10px",
                                        borderRadius: "50%",
                                        backgroundColor: "var(--slider-grey)"
                                    }
                                })
                            ]
                        })
                    });
                },
                renderThumb: function(param) {
                    var props = param.props, isDragged = param.isDragged, index = param.index;
                    var _obj;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", _objectSpread({}, props, {
                        style: _objectSpread({}, props.style),
                        className: (0,clsx_m/* default */.Z)((YearsSelector_module_default()).YearsSelector__thumb, (_obj = {}, YearsSelector_defineProperty(_obj, (YearsSelector_module_default())["YearsSelector__thumb--bottom"], index === 0), YearsSelector_defineProperty(_obj, (YearsSelector_module_default())["YearsSelector__thumb--equalValues"], index === 0 && values1[0] === values1[1]), _obj)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: props["aria-valuenow"]
                        })
                    }));
                }
            })
        ]
    });
};
/* harmony default export */ var MultiDropdownItem_YearsSelector = (YearsSelector);

;// CONCATENATED MODULE: ./components/global/MultiDropdownItem/MultiDropdownItem.tsx
function MultiDropdownItem_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function MultiDropdownItem_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MultiDropdownItem_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









var isSelectedMenuItem = function(selectedFilters, menuFilters) {
    var isIncluded = true;
    menuFilters.forEach(function(f) {
        if (selectedFilters.includes(f.id)) {
            isIncluded = false;
            return;
        }
    });
    return isIncluded;
};
var currentYear = new Date().getFullYear();
var MultiDropdownItem = function(param) {
    var block = param.block, onSelect = param.onSelect, id1 = param.id, itemsCount = param.itemsCount, selectedFiltersIds = param.selectedFiltersIds, setMenuFilters = param.setMenuFilters, onSelectAllNoneCallback = param.onSelectAllNoneCallback;
    var ref8, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,use_dropdown_menu/* default */.Z)(block === null || block === void 0 ? void 0 : (ref8 = block.items) === null || ref8 === void 0 ? void 0 : ref8.length), itemProps = ref6.itemProps, buttonProps = ref6.buttonProps;
    var yearFilters = selectedFiltersIds.filter(function(year) {
        return (0,util/* isNumeric */.kE)(year);
    }) || [];
    var yearFilterToggle = yearFilters.length === 0 ? true : !(yearFilters[0] === (block === null || block === void 0 ? void 0 : block.items[block.items.length - 1].id) && yearFilters[1] === String(currentYear));
    var filterButtonToggle = block.component === "yearsSelector" ? yearFilterToggle : isSelectedMenuItem(selectedFiltersIds, block === null || block === void 0 ? void 0 : block.items);
    var onClick = buttonProps.onClick, buttonPropsRest = _objectWithoutProperties(buttonProps, [
        "onClick"
    ]);
    var handleSelectNone = function() {
        var ref;
        if (block.component === "yearsSelector" && (block === null || block === void 0 ? void 0 : (ref = block.items) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            var current = block.items[0];
            setMenuFilters([
                current,
                current
            ], "year");
        } else {
            var ref7;
            var selectedFilters = block === null || block === void 0 ? void 0 : (ref7 = block.items) === null || ref7 === void 0 ? void 0 : ref7.filter(function(e) {
                return selectedFiltersIds === null || selectedFiltersIds === void 0 ? void 0 : selectedFiltersIds.includes(e.id);
            });
            setMenuFilters(selectedFilters, "remove");
        }
        onSelectAllNoneCallback && onSelectAllNoneCallback();
    };
    var handleSelectAll = function() {
        var ref;
        if (block.component === "yearsSelector" && (block === null || block === void 0 ? void 0 : (ref = block.items) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            setMenuFilters([
                block.items[block.items.length - 1],
                block.items[0]
            ], "year");
        } else {
            setMenuFilters(block === null || block === void 0 ? void 0 : block.items, "add");
        }
        onSelectAllNoneCallback && onSelectAllNoneCallback();
    };
    if (!((ref1 = block.items) === null || ref1 === void 0 ? void 0 : ref1.length)) return null;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                // key={id}
                className: (0,clsx_m/* default */.Z)((MultiDropdownItem_module_default()).DropdownListWrapper, MultiDropdownItem_defineProperty({}, (MultiDropdownItem_module_default())["DropdownListWrapper__right-border"], id1 < itemsCount - 1)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MultiDropdownItem_module_default()).DropdownListTitle,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: block.title
                            }),
                            block.component === "menuItem" && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", MultiDropdownItem_objectSpread({
                                className: (MultiDropdownItem_module_default()).FilterButton,
                                type: "button",
                                onClick: function() {
                                    if (filterButtonToggle) {
                                        handleSelectAll();
                                    } else {
                                        handleSelectNone();
                                    }
                                }
                            }, buttonPropsRest, {
                                children: filterButtonToggle ? "All" : "None"
                            })),
                            block.component === "yearsSelector" && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", MultiDropdownItem_objectSpread({
                                className: (MultiDropdownItem_module_default()).FilterButton,
                                type: "button",
                                onClick: function() {
                                    if (filterButtonToggle) {
                                        handleSelectAll();
                                    } else {
                                        handleSelectNone();
                                    }
                                }
                            }, buttonPropsRest, {
                                children: filterButtonToggle ? "All" : "None"
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: (0,clsx_m/* default */.Z)((MultiDropdownItem_module_default()).DropdownList, // [styles.DropdownListTwoColumn]: block.items.length > 7
                        MultiDropdownItem_defineProperty({}, (MultiDropdownItem_module_default()).DropdownList__yearsSelector, block.component === "yearsSelector")),
                        children: [
                            block.component === "menuItem" && block.items.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: (0,clsx_m/* default */.Z)((MultiDropdownItem_module_default()).DropdownList__item, {
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiDropdownItem_Item, MultiDropdownItem_objectSpread({
                                        item: item,
                                        onSelect: onSelect,
                                        active: selectedFiltersIds === null || selectedFiltersIds === void 0 ? void 0 : selectedFiltersIds.includes(item.id)
                                    }, itemProps[index]))
                                }, item.name);
                            }),
                            block.component === "yearsSelector" && /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiDropdownItem_YearsSelector, {
                                years: block.items,
                                onSelect: onSelect,
                                startYear: Number((ref2 = selectedFiltersIds === null || selectedFiltersIds === void 0 ? void 0 : selectedFiltersIds.filter(function(id) {
                                    return (0,util/* isNumeric */.kE)(id);
                                })) === null || ref2 === void 0 ? void 0 : ref2[0]) || 2009,
                                endYear: Number((ref3 = selectedFiltersIds === null || selectedFiltersIds === void 0 ? void 0 : selectedFiltersIds.filter(function(id) {
                                    return (0,util/* isNumeric */.kE)(id);
                                })) === null || ref3 === void 0 ? void 0 : ref3[1]) || currentYear
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Accordion */.UQ, {
                // key={id}
                className: (0,clsx_m/* default */.Z)((MultiDropdownItem_module_default()).DropdownListWrapper, (MultiDropdownItem_module_default())["DropdownListWrapper--mobile"], (_obj = {}, MultiDropdownItem_defineProperty(_obj, (MultiDropdownItem_module_default())["DropdownListWrapper__right-border"], id1 < itemsCount - 1), MultiDropdownItem_defineProperty(_obj, (MultiDropdownItem_module_default())["DropdownListWrapper__top-border"], id1 === 0), _obj)),
                allowZeroExpanded: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItem */.Qd, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemState */.CB, {
                            children: function(state) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemHeading */.Ol, {
                                    className: (0,clsx_m/* default */.Z)((MultiDropdownItem_module_default()).DropdownListTitle, MultiDropdownItem_defineProperty({}, (MultiDropdownItem_module_default())["DropdownListTitle--active"], state.expanded)),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemButton */.on, {
                                        className: (MultiDropdownItem_module_default()).Accordion__Button,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (MultiDropdownItem_module_default()).Accordion__ButtonContent,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: block.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", MultiDropdownItem_objectSpread({
                                                    className: (MultiDropdownItem_module_default()).FilterButton,
                                                    type: "button",
                                                    onClick: function(e) {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        if (filterButtonToggle) {
                                                            handleSelectAll();
                                                        } else {
                                                            handleSelectNone();
                                                        }
                                                    }
                                                }, buttonPropsRest, {
                                                    children: filterButtonToggle ? "All" : "None"
                                                }))
                                            ]
                                        })
                                    })
                                });
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemPanel */.Mt, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: (0,clsx_m/* default */.Z)((MultiDropdownItem_module_default()).DropdownList, {}),
                                children: [
                                    block.component === "menuItem" && block.items.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: (0,clsx_m/* default */.Z)((MultiDropdownItem_module_default()).DropdownList__item, {}),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiDropdownItem_Item, MultiDropdownItem_objectSpread({
                                                item: item,
                                                onSelect: onSelect,
                                                active: selectedFiltersIds === null || selectedFiltersIds === void 0 ? void 0 : selectedFiltersIds.includes(item.id)
                                            }, itemProps[index]))
                                        }, item.name);
                                    }),
                                    block.component === "yearsSelector" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (MultiDropdownItem_module_default()).DropdownItem__yearSelectorMobile,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiDropdownItem_YearsSelector, {
                                            years: block.items,
                                            onSelect: onSelect,
                                            startYear: Number((ref4 = selectedFiltersIds === null || selectedFiltersIds === void 0 ? void 0 : selectedFiltersIds.filter(function(id) {
                                                return (0,util/* isNumeric */.kE)(id);
                                            })) === null || ref4 === void 0 ? void 0 : ref4[0]) || 2009,
                                            endYear: Number((ref5 = selectedFiltersIds === null || selectedFiltersIds === void 0 ? void 0 : selectedFiltersIds.filter(function(id) {
                                                return (0,util/* isNumeric */.kE)(id);
                                            })) === null || ref5 === void 0 ? void 0 : ref5[1]) || currentYear,
                                            mobile: true
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var MultiDropdownItem_MultiDropdownItem = (MultiDropdownItem);

;// CONCATENATED MODULE: ./components/global/MultiDropdownItem/index.tsx


// EXTERNAL MODULE: ./components/global/MultiDropdown/MultiDropdown.module.scss
var MultiDropdown_module = __webpack_require__(51947);
var MultiDropdown_module_default = /*#__PURE__*/__webpack_require__.n(MultiDropdown_module);
;// CONCATENATED MODULE: ./components/global/MultiDropdown/MultiDropdown.tsx
function MultiDropdown_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function MultiDropdown_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MultiDropdown_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var MultiDropdown = function(param) {
    var items = param.items, defaultValue = param.defaultValue, onSelect = param.onSelect, size = param.size, transparency = param.transparency, color = param.color, align = param.align, id = param.id, _direction = param.direction, direction = _direction === void 0 ? "down" : _direction, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _inline = param.inline, inline = _inline === void 0 ? false : _inline, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _active = param.active, active = _active === void 0 ? false : _active, _showDropdown = param.showDropdown, showDropdown = _showDropdown === void 0 ? true : _showDropdown, _transparentMenu = param.transparentMenu, transparentMenu = _transparentMenu === void 0 ? false : _transparentMenu, _scrollOnChange = param.scrollOnChange, scrollOnChange = _scrollOnChange === void 0 ? true : _scrollOnChange, title = param.title, selectedFiltersIds = param.selectedFiltersIds, setMenuFilters = param.setMenuFilters, dropdownListChildren = param.dropdownListChildren, onSelectAllNoneCallback = param.onSelectAllNoneCallback;
    var router = (0,next_router.useRouter)();
    var ref = (0,use_dropdown_menu/* default */.Z)(items === null || items === void 0 ? void 0 : items.length), buttonProps = ref.buttonProps, itemProps = ref.itemProps, isOpen = ref.isOpen, setIsOpen = ref.setIsOpen;
    var handleSelect = function(item) {
        // setIsOpen(false);
        onSelect(item);
        return item;
    };
    var onKeyDown = function(event) {
    // const selectedIndex = items.findIndex((item) => item.name === selectedValue);
    // if (event.key === 'ArrowDown' && selectedIndex !== items.length - 1) {
    //   onSelect(items[selectedIndex + 1]);
    // } else if (event.key === 'ArrowUp' && selectedIndex !== 0) {
    //   onSelect(items[selectedIndex - 1]);
    // } else if (event.key === 'Tab') {
    //   setIsOpen(false);
    // }
    };
    if (!(items === null || items === void 0 ? void 0 : items.length)) return null;
    var _obj, _obj1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: id,
        className: (0,clsx_m/* default */.Z)((MultiDropdown_module_default()).DropdownContainer, {}),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", MultiDropdown_objectSpread({
                type: "button",
                className: (0,clsx_m/* default */.Z)((MultiDropdown_module_default()).Button, (_obj = {}, MultiDropdown_defineProperty(_obj, (MultiDropdown_module_default()).ButtonSmall, size === "small"), MultiDropdown_defineProperty(_obj, (MultiDropdown_module_default()).DropdownIsActive, isOpen), MultiDropdown_defineProperty(_obj, (MultiDropdown_module_default()).ButtonFullWidth, fullWidth), _obj))
            }, buttonProps, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (MultiDropdown_module_default()).ButtonText,
                        children: title
                    }),
                    showDropdown && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (MultiDropdown_module_default()).ButtonIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, MultiDropdown_objectSpread({
                            iconName: "arrow-".concat(isOpen ? "up" : "down")
                        }, defaultIconSizes/* DEFAULT_ARROW_ICON_SIZES */.G))
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)((MultiDropdown_module_default()).DropdownListWrapper, (_obj1 = {}, MultiDropdown_defineProperty(_obj1, (MultiDropdown_module_default()).DropdownListVisible, isOpen), MultiDropdown_defineProperty(_obj1, (MultiDropdown_module_default()).DropdownListWrapperSmall, size === "small"), _obj1)),
                role: "menu",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (MultiDropdown_module_default()).DropdownListWrapper__items,
                        children: items.map(function(block, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiDropdownItem_MultiDropdownItem, {
                                block: block,
                                id: index,
                                itemsCount: items.length,
                                onSelect: handleSelect,
                                selectedFiltersIds: selectedFiltersIds,
                                setMenuFilters: setMenuFilters,
                                onSelectAllNoneCallback: onSelectAllNoneCallback
                            }, index);
                        })
                    }),
                    dropdownListChildren
                ]
            })
        ]
    });
};
/* harmony default export */ var MultiDropdown_MultiDropdown = (MultiDropdown);


/***/ }),

/***/ 36551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_NoResults; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./components/global/NoResults/NoResults.module.scss
var NoResults_module = __webpack_require__(56980);
var NoResults_module_default = /*#__PURE__*/__webpack_require__.n(NoResults_module);
;// CONCATENATED MODULE: ./components/global/NoResults/NoResults.tsx


var NoResults = function(param) {
    var title = param.title, text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (NoResults_module_default()).noresults,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: text
            })
        ]
    });
};
/* harmony default export */ var NoResults_NoResults = (NoResults);

;// CONCATENATED MODULE: ./components/global/NoResults/index.tsx

/* harmony default export */ var global_NoResults = (NoResults_NoResults);


/***/ }),

/***/ 57758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BaseSeo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59370);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52375);



var trimTrailingSlash = function(slug) {
    return slug[slug.length - 1] === "/" ? slug.slice(0, slug.length - 1) : slug;
};
var BaseSeo = function(param) {
    var title = param.title, ogTitle = param.ogTitle, description = param.description, ogDescription = param.ogDescription, path = param.path, image = param.image;
    var canonical = path ? "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O).concat(trimTrailingSlash(path)) : _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O;
    var baseTitle = _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_NAME */ .px;
    var baseDescription = "Colophon is an international, award-winning type foundry based in London (UK) and Los Angeles (US). We create, publish, and distribute high-quality retail and custom typefaces for analog and digital media.";
    var seoTitle = title || baseTitle;
    var seoDescription = description || baseDescription;
    var twitter = _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SOCIAL_TWITTER_ID */ .R1 ? {
        handle: _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SOCIAL_TWITTER_ID */ .R1,
        cardType: "summary_large_image"
    } : null;
    var openGraph = {
        url: canonical,
        title: ogTitle || seoTitle,
        description: ogDescription || seoDescription,
        images: [
            {
                url: "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O).concat(image ? image : "/img/og.png"),
                alt: "Colophon Foundry"
            }
        ],
        site_name: "Colophon Foundry"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: seoTitle,
        description: seoDescription,
        canonical: canonical,
        twitter: twitter,
        openGraph: openGraph
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseSeo);


/***/ }),

/***/ 47659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ Storyblok; },
  "P": function() { return /* reexport */ useStoryblok; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
;// CONCATENATED MODULE: ./storyblok/hooks/useStoryblok.ts


function useStoryblok(originalStory, preview) {
    var resolve_relations = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var initEventListeners = // adds the events for updating the visual editor
    // see https://www.storyblok.com/docs/guide/essentials/visual-editor#initializing-the-storyblok-js-bridge
    function initEventListeners() {
        var StoryblokBridge = window.StoryblokBridge;
        if (typeof StoryblokBridge !== "undefined") {
            // initialize the bridge with your token
            var storyblokInstance = new StoryblokBridge({
                resolveRelations: resolve_relations
            });
            // reload on Next.js page on save or publish event in the Visual Editor
            storyblokInstance.on([
                "change",
                "published"
            ], function() {
                return location.reload();
            });
            // live update the story on input events
            storyblokInstance.on("input", function(event) {
                // check if the ids of the event and the passed story match
                if (story && event.story.content._uid === story.content._uid) {
                    // change the story content through the setStory function
                    setStory(event.story);
                }
            });
            storyblokInstance.on("enterEditmode", function(event) {
                // loading the draft version on initial enter of editor
                Storyblok.get("cdn/stories/".concat(event.storyId), {
                    resolve_relations: resolve_relations,
                    version: "draft"
                }).then(function(param) {
                    var data = param.data;
                    if (data.story) {
                        setStory(data.story);
                    }
                }).catch(function(error) {
                    console.log(error);
                });
            });
        }
    };
    var addBridge = // appends the bridge script tag to our document
    // see https://www.storyblok.com/docs/guide/essentials/visual-editor#installing-the-storyblok-js-bridge
    function addBridge(callback) {
        // check if the script is already present
        var existingScript = document.getElementById("storyblokBridge");
        if (!existingScript) {
            var script = document.createElement("script");
            script.src = "//app.storyblok.com/f/storyblok-v2-latest.js";
            script.id = "storyblokBridge";
            document.body.appendChild(script);
            script.onload = function() {
                // once the scrip is loaded, init the event listeners
                callback();
            };
        } else {
            callback();
        }
    };
    var ref = (0,react.useState)(originalStory), story = ref[0], setStory = ref[1];
    (0,react.useEffect)(function() {
        // only load inside preview mode
        if (preview) {
            // first load the bridge, then initialize the event listeners
            addBridge(initEventListeners);
        }
    }, [
        originalStory,
        preview,
        setStory
    ]); // runs the effect only once & defines effect dependencies
    return story;
}

// EXTERNAL MODULE: ./node_modules/.pnpm/storyblok-js-client@4.5.6_axios@0.21.4/node_modules/storyblok-js-client/dist/index.es.js
var index_es = __webpack_require__(78578);
;// CONCATENATED MODULE: ./storyblok/lib/storyblok.js

var STORYBOOK_API_KEY = "WygMRPInxMCOSMUw1Vt4TAtt";
var Storyblok = new index_es/* default */.Z({
    accessToken: STORYBOOK_API_KEY,
    cache: {
        clear: "auto",
        type: "memory"
    }
});

;// CONCATENATED MODULE: ./storyblok/index.ts




/***/ }),

/***/ 51947:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"DropdownContainer":"MultiDropdown_DropdownContainer__9Iqxp","DropdownContainerWide":"MultiDropdown_DropdownContainerWide__bc3no","DropdownContainerTransparent":"MultiDropdown_DropdownContainerTransparent__uHeoK","DropdownContainerInline":"MultiDropdown_DropdownContainerInline__SYJqq","Button":"MultiDropdown_Button__6p1__","ButtonSmall":"MultiDropdown_ButtonSmall__xL83R","DropdownIsActive":"MultiDropdown_DropdownIsActive__qPjAH","ButtonIcon":"MultiDropdown_ButtonIcon__dh1KQ","ButtonFullWidth":"MultiDropdown_ButtonFullWidth__qwdt4","DropdownListWrapper":"MultiDropdown_DropdownListWrapper__O9g8R","DropdownListWrapper__items":"MultiDropdown_DropdownListWrapper__items__0m_eY","DropdownListWrapperSmall":"MultiDropdown_DropdownListWrapperSmall__xFZO0","DropdownListVisible":"MultiDropdown_DropdownListVisible__wLAhN"};

/***/ }),

/***/ 75288:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"DropdownListWrapper":"MultiDropdownItem_DropdownListWrapper__HHI1l","FilterButton":"MultiDropdownItem_FilterButton__Wn2BK","DropdownList":"MultiDropdownItem_DropdownList__vSQXK","DropdownList__item":"MultiDropdownItem_DropdownList__item__Q4_VE","DropdownList__yearsSelector":"MultiDropdownItem_DropdownList__yearsSelector__aA_In","DropdownListTwoColumn":"MultiDropdownItem_DropdownListTwoColumn__RdgJE","firstColumnLastIndex":"MultiDropdownItem_firstColumnLastIndex__MmoQx","DropdownListWrapper__right-border":"MultiDropdownItem_DropdownListWrapper__right-border__GcLh8","DropdownListWrapper__top-border":"MultiDropdownItem_DropdownListWrapper__top-border__sGsk9","DropdownListTitle":"MultiDropdownItem_DropdownListTitle__OIHCp","DropdownListWrapper--mobile":"MultiDropdownItem_DropdownListWrapper--mobile__eS0_A","DropdownListTitle--active":"MultiDropdownItem_DropdownListTitle--active__Wait_","DropdownItem__two-cols":"MultiDropdownItem_DropdownItem__two-cols__GlBas","DropdownItem__yearSelector":"MultiDropdownItem_DropdownItem__yearSelector__IaG31","DropdownItem__yearSelectorMobile":"MultiDropdownItem_DropdownItem__yearSelectorMobile__zHaks","DropdownItem--active":"MultiDropdownItem_DropdownItem--active__q5XYa","Accordion__Button":"MultiDropdownItem_Accordion__Button__UkXUC","Accordion__ButtonContent":"MultiDropdownItem_Accordion__ButtonContent__vs5U4"};

/***/ }),

/***/ 71069:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"YearsSelector__track":"YearsSelector_YearsSelector__track__s25LC","YearsSelector__trackInner":"YearsSelector_YearsSelector__trackInner__wukWw","YearsSelector__thumb":"YearsSelector_YearsSelector__thumb__qES0Y","YearsSelector__thumb--bottom":"YearsSelector_YearsSelector__thumb--bottom__vvDRD","YearsSelectorMobile__track":"YearsSelector_YearsSelectorMobile__track__3XNcv","YearsSelectorMobile__trackInner":"YearsSelector_YearsSelectorMobile__trackInner__HQStd","YearsSelectorMobile__thumb":"YearsSelector_YearsSelectorMobile__thumb__O_yuR","YearsSelectorMobile__thumb--right":"YearsSelector_YearsSelectorMobile__thumb--right__BbZnC"};

/***/ }),

/***/ 56980:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"noresults":"NoResults_noresults__OvBkI"};

/***/ })

}]);